<template>
  <nav class="navbar navbar-expand-lg  fixed-top">
    <div class="container-fluid">
      <router-link class="navbar-brand" to="/enterprise/vacancies" v-if="canAccess('enterprise')">
        <NavLogoEnterprise style="height:1.9rem!important;"/>
        <!-- <img class="nav-logo" src="../../assets/images/vocation-enterprise.svg" style="height:1.9rem!important;"/> -->
      </router-link>
      <router-link class="navbar-brand" style="display:flex;" to="/" v-else>
        <NavLogo style="/*height:1.9rem!important;*/"/>
        <!-- <img class="nav-logo" src="../../assets/images/vocation.svg"/> -->
      </router-link>
      <div class="navbar-toggler">
        <button class="btn btn-default navbar-toggler-btn"
              @click="toggleTheme"
              type="button" style="border:0px;">
              <ThemeIcon ref="themeIcon"/>
        </button>   
      <button
        class="btn btn-default navbar-toggler-btn"
        type="button"
         @click="toggleNavbar"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        style="border:0px;">
        <MenuButtonIcon/>
      </button>
      </div>

      <div class="collapse navbar-collapse" id="navbarSupportedContent" ref="navbarCollapse">
        <!-- Left side nav -->
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item" v-if="!canAccess('enterprise')">
            <router-link class="nav-link" to="/">Home</router-link>
          </li>
          <li class="nav-item" v-if="!canAccess('enterprise') && !canAccess('admin')">
            <router-link class="nav-link" to="/about">About</router-link>
          </li>

          <li class="nav-item" v-if="!isAuthenticated">
            <router-link class="nav-link" to="/billing">Billing</router-link>
          </li>

          
          <!-- <li class="nav-item" v-if="!isAuthenticated">
            <router-link class="nav-link" to="/privacy-policy">Privacy Policy</router-link>
          </li>
          <li class="nav-item" v-if="!isAuthenticated">
            <router-link class="nav-link" to="/terms-of-service">Terms Of Service</router-link>
          </li> -->

           <li class="nav-item dropdown" v-if="!isAuthenticated">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
              More
            </a>
            <ul class="dropdown-menu">
              <li><router-link class="dropdown-item" to="/privacy-policy">Privacy Policy</router-link></li>
              <li><router-link class="dropdown-item" to="/terms-of-service">Terms Of Service</router-link></li>
              
            </ul>
          </li>


           <li class="nav-item"  v-if="!isAuthenticated">
            <router-link class="nav-link" to="/contact-us">Contact Us</router-link>
          </li>

          <li class="nav-item" v-if="isAuthenticated && canAccess('admin')">
                    <router-link class="nav-link" to="/admin/dashboard">Dashboard</router-link>
          </li>
          
          <li class="nav-item" v-if="isAuthenticated && canAccess('admin')">
                    <router-link class="nav-link" to="/admin/job-seekers">Job Seekers</router-link>
          </li>
            <li class="nav-item" v-if="isAuthenticated && canAccess('admin')">
                    <router-link class="nav-link" to="/admin/employers">Businesses</router-link>
          </li>
         <!-- <li class="nav-item" v-if="canAccess('enterprise')">
                    <router-link class="nav-link" to="/enterprise/contact-us">Contact Us</router-link>
          </li> -->
         

          <li v-if="isAuthenticated && !canAccess('enterprise')" class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
              {{ authUser.fullname }}
            </a>
            <ul class="dropdown-menu">
              <li v-if="!canAccess('admin')"><router-link class="dropdown-item" to="/my-account">My Account</router-link></li>
              <!-- Conditionally show these links depending on the current user's roles
                   `canAccess(routeName)` returns true when the resolved route's meta
                   allows the authenticated user to view that route. -->
              <li><router-link class="dropdown-item" to="/myjobs" v-if="canAccess('myjobs') && !canAccess('admin')">My Jobs</router-link></li>
              <li><router-link class="dropdown-item" to="/cv-builder" v-if="canAccess('cv-builder') && !canAccess('admin')">CV Builder</router-link></li>
              <li><hr class="dropdown-divider"></li>
              <li>
                <span class="dropdown-item logout" @click="logOut">Sign Out</span>
              </li>
            </ul>
          </li>

          <li class="nav-item dropdown" v-if="isAuthenticated && !canAccess('enterprise') && !canAccess('admin')">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
              More
            </a>
            <ul class="dropdown-menu">
              <li><router-link class="dropdown-item" to="/billing">Billing</router-link></li>
              <li><router-link class="dropdown-item" to="/privacy-policy">Privacy Policy</router-link></li>
              <li><router-link class="dropdown-item" to="/terms-of-service">Terms Of Service</router-link></li>
              <li><router-link class="dropdown-item" to="/contact-us">Contact Us</router-link></li>
              <!-- <li><hr class="dropdown-divider"></li>
              <li>
                <span class="dropdown-item logout" @click="logOut">Sign Out</span>
              </li> -->
            </ul>
          </li>
        </ul>

        <!-- Right side nav -->
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0 right-side">
          <li class="nav-item" :class="!isAuthenticated || !canAccess('enterprise') ? 'first-child-with-others':''" v-if="!isAuthenticated || !canAccess('enterprise')">
            <input class="form-control search-input" v-model="searchTerm" @keyup.enter="startSearch" placeholder="Search companies, recruiters"/>
          </li>
          <li class="nav-item" v-if="!isAuthenticated">
            <router-link class="nav-link" to="/login">Login</router-link>
          </li>
          <li class="nav-item" v-if="!isAuthenticated">
            <router-link class="nav-link" to="/signup">Sign Up</router-link>
          </li>
          <li class="nav-item hidden-on-mobile">
             <button class="btn btn-default nav-link"
              @click="toggleTheme"
              type="button" style="border:0px;color:var(--nav-icon);">
              <ThemeIcon style="margin-top:-0.11rem;" ref="themeIcon2"/>
            </button>    
          </li>
          
        </ul>

        <!-- Search form -->
        <!-- <form class="d-flex ms-2" role="search">
          <input class="form-control me-2" type="search" placeholder="Jobs, Companies" aria-label="Search"/>
          <button class="btn btn-outline-success btn-search" type="submit">Search</button>
        </form> -->
      </div>
    </div>
  </nav>
</template>
<script setup>
import { ref, onMounted, computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import Collapse from 'bootstrap/js/dist/collapse'
import Dropdown from 'bootstrap/js/dist/dropdown'
import { useStore } from 'vuex'
import NavLogo from '@/components/IconComponents/NavLogo.vue'
import NavLogoEnterprise from '@/components/IconComponents/NavLogoEnterprise.vue'
import MenuButtonIcon from '@/components/IconComponents/MenuButtonIcon.vue'
import HomeIcon from '@/components/IconComponents/HomeIcon.vue'
import ThemeIcon from '@/components/IconComponents/ThemeIcon.vue'
import { search } from '@/store/public/search'

let navbarCollapse = ref(null);
let router = useRouter();
let store = useStore();
const themeIcon = ref(null);
const themeIcon2 = ref(null);
let bsCollapse = null;
let searchTerm = ref('');

onMounted(() => {
 initializeNavbarCollapse()
  // Dropdown logic: find all toggles and instantiate
  // let dropdownToggleList = [].slice.call(
  //   document.querySelectorAll('[data-bs-toggle="dropdown"]')
  // );
  // dropdownToggleList.forEach((dropdownToggleEl) => {
  //   new Dropdown(dropdownToggleEl)
  // });
})

let isAuthenticated = computed(() => store.getters['auth/isAuthenticated']);

let authUser = computed(() => store.getters['auth/getAuthenticatedUser']);

// Sync the local input field whenever the Vuex store search term changes/clears
watch(
  () => store.getters['search/getSearchTerm'],
  (newVal) => {
    searchTerm.value = newVal || '';
  }
)

function logOut(){
  store.dispatch('auth/logout');
  router.push({path:'/login',
              query:{
                message:"You have been logged out"
              }
  });
}

/**
 * canAccess(routeName)
 * - Resolves the named route and reads its `meta` (e.g. `requiresAuth`, `roles`).
 *   whether the current user is allowed to see links for that route.
 *
 * Returns `true` when:
 *  - the route exists, and
 *  - if `requiresAuth` is set then a token exists, and
 *  - if `roles` is set then the user's role matches one of the allowed roles.
 */
function canAccess(routeName) {
  // Resolve the route by name. `resolved.matched` contains the matched route records.
  const resolved = router.resolve({ name: routeName })

  // Use the most-specific matched record (last entry) so child route meta is respected.
  const matched = resolved?.matched || []
  if (!matched.length) return false // route not found

  const record = matched[matched.length - 1]
  const meta = record.meta || {}

  // Read token from localStorage (used by guards elsewhere in the app).
  const token = localStorage.getItem('token')

  // Prefer the `authUser` from the Vuex store. Fall back to the `user` stored in localStorage.
  let user = authUser.value
  if (!user) {
    try {
      user = JSON.parse(localStorage.getItem('user'))
    } catch (e) {
      user = null
    }
  }

  // If the route requires authentication and there's no token, deny access.
  if (meta.requiresAuth && !token) {
    return false
  }

  // If the route specifies allowed roles, check the user's role in multiple possible shapes:
  //  - user.roles: an array of role strings
  //  - user.userType: a single role stored under `userType` (used in signup)
  //  - user.role: another common single-role field
  if (meta.roles) {
    let hasRole = false
    if (Array.isArray(user?.roles)) {
      hasRole = user.roles.some(role => meta.roles.includes(role))
    } else if (user?.userType) {
      hasRole = meta.roles.includes(user.userType)
    } else if (user?.role) {
      hasRole = meta.roles.includes(user.role)
    }
    if (!hasRole) return false
  }

  // No checks failed — allow access.
  return true
}

function toggleTheme(){   
            let savedTheme = localStorage.getItem('theme');  
            if(savedTheme === 'dark'){
              document.body.classList.remove('darkmode')
              localStorage.setItem('theme', 'light');               
            }else{
                document.body.classList.add('darkmode')
                localStorage.setItem('theme', 'dark');  
            }
          themeIcon.value.toggleThemeIcon();
          themeIcon2.value.toggleThemeIcon();
        }

function initializeNavbarCollapse(){
   bsCollapse = new Collapse(navbarCollapse.value, { toggle: false })

  router.afterEach(() => {
    bsCollapse.hide()
  })
}

function toggleNavbar() {
  if (navbarCollapse.value.classList.contains('show')) {
    bsCollapse.hide()
  } else {
    bsCollapse.show()
  }
}

function startSearch(){
  const query = searchTerm.value.trim()
  if (!query) return

 
  // // 1. Send the raw string value to Vuex ONLY when Enter is pressed
  store.dispatch('search/updateSearchTerm', query)

  // // 2. Navigate to search results page
  router.push({ path: '/search-results' })
}

</script>

<style scoped>


  

  :deep(.nav-link.dropdown-toggle.show){
    color: var(--navlink-active);
  }

  :deep(.nav-link.dropdown-toggle){
    color:var(--navlink);
  }

  .dropdown-item:active{
    background:var(--background);
  }

  .dropdown-item:hover{
    background:var(--nav);
  }

  .dropdown-item{
    font-size:0.8rem;
  }
  .nav-logo{
    height:1.5rem!important;
  }

  .logout{
    cursor: pointer;
    color:var(--navlink);
  }

   .logout:hover{
    color:var(--navlink-active);
  }
  .navbar-brand{
    font-style: italic;
    font-weight: bold;
    color:var(--logo);
  }

  .btn-search{
    border:0px;
    color:white;
    background-color: var(--primary);
  }

  nav{
    border-bottom:1px solid var(--nav-border);
    background:var(--nav);
  }

  nav a{
    color:var(--navlink);
  }
  

  nav a.router-link-exact-active {
  color: var(--navlink-active);
}

.exact-active-link{
  color: var(--navlink-active);
}

nav a:hover{
    color: var(--navlink-active);

  }

  .navbar-toggler{
    padding:0rem 0.1rem;
    border:0px!important;
    color:var(--nav-icon)!important;
  }

  .navbar-toggler-btn{
    color:var(--nav-icon)!important;
    
  }

  .nav-link{
    padding:0rem;
    font-size:0.8rem;
  }
  .nav-link-icon{
    height:0.8rem;
    justify-self: center;
  }

  .nav-link-text{
    font-size:0.8rem;
  }

  .nav-item{
    margin:0.6rem 0rem!important;
    
  }

  .dropdown-menu{
    background:var(--nav);
    border-radius:12px;
    border:0px;
    
  }

  .search-input{
    background-color:var(--background)!important;
    color:var(--foreground)!important;
    border:0px!important;
    min-width:20rem; 
  }

  .navbar.navbar-expand-lg.fixed-top{
    padding: 0.1rem 0rem
  }

  

  .first-child-with-others{
     margin-right: 1rem!important;
  }

  .right-side .nav-item:nth-child(2){
    padding-top:0.49rem;
  }

   .right-side .nav-item:nth-child(3){
    padding-top:0.49rem;
  }

   .right-side .nav-item:nth-child(4){
    padding-top:0.46rem;
  }

  

    @media(max-width:768px) {
        li{
           text-align: start;
        }

        .hidden-on-mobile{
          display: none;
        }

        .nav-item{
          padding:0rem!important;
          }

           .navbar.navbar-expand-lg.fixed-top{
              padding: 8px 0px
            }

           .first-child-with-others{
              margin-right: 0rem!important;
            }

          .right-side .nav-item:nth-child(2){
              padding-top:0rem;
            }

            .right-side .nav-item:nth-child(3){
              padding-top:0rem;
            }

            .right-side .nav-item:nth-child(4){
              padding-top:0rem;
            }

            .search-input{
                min-width:auto;
                
                
              }


    }
</style>